module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "wx-loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.content))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04ced10d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tempControl/wxLoading.vue
// module id = 889
// module chunks = 1